import { PropTypes } from 'prop-types';
//Importaciones temporales
import ProjectCard from './components/ProjectCard';

const ProjectsList = ({ allProjects }) => {
  return (
    <div className="wrapper">
      <div className="row row-project" style={{ background: 'none' }}>
        {allProjects.map((project) => {
          return <ProjectCard project={project} key={project.id_project} />;
        })}
      </div>
    </div>
  );
};

ProjectsList.propTypes = {
  allProjects: PropTypes.arrayOf(PropTypes.object),
};

ProjectsList.defaultProps = {
  allProjects: [],
};

export default ProjectsList;
